import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { placeholder, rgba } from "polished";
import { Box, Flex, Image } from "rebass";
import { H4 } from "components";

const InnerWrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: ${props => props.theme.colors.grey[2]};
  border-radius: 0;
  border: 1px solid ${props => rgba(props.theme.colors.text, 1 / 5)};

  /* Naked */
  ${props =>
    props.appearance === "naked" &&
    css`
      background-color: transparent;
      border-radius: 0;
      border: none;
    `};
`;

const InputComp = styled.input`
  width: 100%;
  max-width: none;
  padding-top: 13px;
  padding-right: 16px;
  padding-bottom: 11px;
  padding-left: ${props => (props.icon ? 40 : 16)}px;

  font-weight: 400;
  color: ${props => props.theme.colors.text};

  background-color: transparent;
  border: 0;

  ${placeholder({ color: "rgba(0, 0, 0, 0.333)" })};

  /* Naked */
  ${props =>
    props.appearance === "naked" &&
    css`
      padding-right: 0;
      padding-left: ${props => (props.icon ? 24 : 0)}px;
    `};
`;

const Input = props => (
  <div>
    {props.label && (
      <H4
        children={props.label}
        is="label"
        htmlFor={props.uid}
        heading={0}
        mb={1}
      />
    )}
    <InnerWrapper maxWidth={props.maxWidth} appearance={props.appearance}>
      <InputComp
        id={props.uid}
        name={props.name}
        appearance={props.appearance}
        {...props}
        aria-labelledby={props.uid}
      />
    </InnerWrapper>
  </div>
);

Input.defaultProps = {
  type: "text"
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input.js